import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { ItemStockReportViewModel } from 'src/app/viewmodels/g-item/ItemStockReportViewModel';
import { StockAdjustmentViewModel } from 'src/app/viewmodels/g-item/StockAdjustmentViewModel';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { StockAdjustmentDetailViewModel } from 'src/app/viewmodels/g-item/StockAdjustmentDetailViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { SaveStockAdjustmentRequest, StockAdjustmentDetailModel } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';

@Component({
  selector: 'app-stock-adjustment-list',
  templateUrl: './stock-adjustment-list.component.html',
  styleUrls: ['./stock-adjustment-list.component.scss']
})
export class StockAdjustmentListComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  public modalRef: BsModalRef;
  public itemVm: ItemStockReportViewModel = new ItemStockReportViewModel();
  public vmS: SaveStockAdjustmentRequest = new SaveStockAdjustmentRequest();
  public vmD: StockAdjustmentDetailModel = new StockAdjustmentDetailModel();
  public vmListItems: any = [];
  dataTable: any;
  @Input('dataTable') table;
  public stockbyid: any = [];
  dtOption: any = {};
  public component_Title = 'Stock Adjustment List';
  public SortBy: string = "asc";
  private submitted = false;
  public IsDisable = false;
  public isSave = false;
  public isfetch = false;
  public nowDate: Date;
  public calingUrl: string;
  public urlId: number;

  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private http: HttpClient,
    public _router: Router,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.getList();
    $('table.display').DataTable();

    //   this.getStockList();
    //   this.dtOption = {
    //     "paging":   false,
    //     "searching": false,
    //     "info": false,
    // };
    // $(() =>{
    //   $('table.display').DataTable(this.dtOption);
    // })
  }

  // getStockList(){
  //   this.spinner.show();
  //   this.vmS = new StockAdjustmentViewModel();
  //   this._jq.showSpinner(true);
  //   this._uow.itemService.GetStockAdjustedItemReport().subscribe((res: any) => {
  //     this.vmListItems = res.DtlList;
  //     this.vmD = res.DtlList;
  //     this.TotalStockAmount();
  //     console.log(res);
  //     // this._jq.showSpinner();
  //     this.spinner.hide();
  //   }, (err) => {
  //     console.log(err);
  //     // this._jq.showSpinner();
  //     this.spinner.hide();

  //   });
  // }

  // public searchTerm = '';
  // getBySearchTerm(e) {
  //   if (this.searchTerm !== ' ') {
  //     // this._jq.showSpinner(true);
  //     this.spinner.show();
  //     this._uow.itemService.GetStockPagedBySearch(this.searchTerm).subscribe((res: any) => {
  //       this.p = 1;
  //       this.vmListItems = res.DtlList;
  //       // this._jq.showSpinner();
  //       this.spinner.hide();
  //     }, (error) => {
  //       console.log(error);
  //       // this._jq.showSpinner();
  //       this.spinner.hide();
  //     });
  //   }
  // }

  getList() {
    this.spinner.show();
    debugger
    const search = { Name: this.searchTerm }; // adapt per page
    this._uow.gPurchaseService.getList("GPurchase", "GetStockAdjustmentsAsync", this.p, this.size, search, this.orderBy, this.sort)
      .subscribe({
        next: (res: any) => {
          debugger
          this.vmListItems = res.result;
          this.vmD = res.result;
          this.totalItems = res.total;
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        }
      });
  }

  // called when user types in search box
  getBySearchTerm(event: any) {
    debugger
    this.searchTerm = event.target.value.trim();
    this.p = 1; // reset to first page
    this.getList();
  }

  // pagination handler
  onPageChange(page: number) {
    debugger
    this.p = page;
    this.getList();
  }

  // sorting handler (toggle Asc/Desc)
  getSortIndexList(column: string) {
    this.orderBy = column;
    this.sort = this.sort === 'Asc' ? 'Desc' : 'Asc';
    this.getList();
  }


  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    debugger
    this.openModal(template, 1);
    this.modalRef.setClass('modal-xl');
  }
  openSaveBulkAdjustmentModel(template: TemplateRef<any>, model?) {
    debugger
    this.openModal(template, 1);
    this.modalRef.setClass('modal-xl');
  }

  openViewModel(template: TemplateRef<any>, b, model?) {
    debugger
    this.openModal(template, 1);
    this.modalRef.setClass('modal-xl');
    this.calingUrl = this._router.url;
    this._uow.gPurchaseService.GetStockAdjustmentByIdAsync(b.uniqueId).subscribe((res: any) => {
      this.vmS = res;
      this.vmS.transactionDate = new Date(res.transactionDate);
      this.isSave == true;
      this.isfetch == true;
      console.log(this.vmS);
    }, (err) => {
      console.log(err);
    });
  }


  openModal(template: TemplateRef<any>, lvl: number) {
    if (lvl == 1) {
      this.modalRef = this._modalService.show(template, {
        backdrop: true,
        ignoreBackdropClick: true
      });
    }
    if (lvl == 2) {
      this.modalRef = this._modalService.show(template, {
        backdrop: true,
        ignoreBackdropClick: true
      });
    }
  }

  onItemSubmitted(e) {
    debugger
    console.log(e);
    if (e === true) {
      this.vmS = new SaveStockAdjustmentRequest();
      this.getList();
    }
  }

  // getSortIndexList(sIndex) {
  //   debugger
  //   this._jq.showSpinner(true);
  //   this.SortBy = this.SortBy == "asc" ? "desc" : "asc";
  //   this._uow.itemService.GetStockPagedResult(0, 50, null, sIndex, this.SortBy).subscribe((res: any) => {
  //     debugger
  //     this._jq.reinitDataTable(res);
  //     this.vmListItems = res.DtlList;;
  //     console.log(res);
  //     this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //   });
  // }

  StockChange(e) {
    debugger
    if (e.NewQuantity != e.OldQuantity) {
      let diff = 0;
      let NewAmount = e.CostofGoodSold * e.NewQuantity;
      if (NewAmount > e.NewAmount) {
        diff = NewAmount - e.NewAmount;
        this.vmS.amount += diff;
      } else {
        diff = e.NewAmount - NewAmount;
        this.vmS.amount -= diff;
      }
      e.NewAmount = e.CostofGoodSold * e.NewQuantity;
      if (this.vmS.stockAdjustmentDetail == undefined) {
        this.vmS.stockAdjustmentDetail = [];
      }
      let stockDetail = this.vmS.stockAdjustmentDetail.find(x => x.item.id === e.item.id);
      if (stockDetail == undefined) {
        let stockadjustmentDetail = new StockAdjustmentDetailModel();
        stockadjustmentDetail.id = 0;
        stockadjustmentDetail.item = new ItemViewModel1(e.item.id, e.item.name);
        stockadjustmentDetail.newQuantity = e.newQuantity;
        stockadjustmentDetail.oldQuantity = e.oldQuantity;
        stockadjustmentDetail.costOfGoodSold = e.costOfGoodSold;
        stockadjustmentDetail.newAmount = e.newAmount;
        stockadjustmentDetail.totalAmount = e.totalAmount;
        this.vmS.stockAdjustmentDetail.push(stockadjustmentDetail);
      } else {
        let sD = this.vmS.stockAdjustmentDetail.indexOf(stockDetail);
        this.vmS.stockAdjustmentDetail[sD].newQuantity = e.newQuantity;
        this.vmS.stockAdjustmentDetail[sD].newAmount = e.newAmount;
      }
    } else {
      if (this.vmS.stockAdjustmentDetail != undefined) {
        let stockDetail = this.vmS.stockAdjustmentDetail.find(x => x.item.id === e.item.id);
        if (stockDetail != undefined) {
          let diff = 0;
          let NewAmount = e.costOfGoodSold * e.newQuantity;
          if (NewAmount > e.newAmount) {
            diff = NewAmount - e.newAmount;
            this.vmS.amount += diff;
          } else {
            diff = e.newAmount - NewAmount;
            this.vmS.amount -= diff;
          }
          e.newAmount = e.costOfGoodSold * e.newQuantity;
          let sD = this.vmS.stockAdjustmentDetail.indexOf(stockDetail);
          this.vmS.stockAdjustmentDetail[sD].newQuantity = e.newQuantity;
          this.vmS.stockAdjustmentDetail[sD].newAmount = e.newAmount;
        }
      }
    }
  }

  TotalStockAmount() {
    this.vmListItems.forEach(e => {
      this.vmS.amount += e.newAmount;
      this.vmS.lastAmount += e.totalAmount;
    });
  }

  openModel(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-xl');
  }

  openView(template: TemplateRef<any>, b, model?) {
    this.openModel(template);
    debugger
    this._uow.gPurchaseService.GetStockAdjustmentByIdAsync(b.uniqueId).subscribe((res: any) => {
      debugger
      this.stockbyid = res;
      console.log(this.stockbyid);
    }, (err) => {
      console.log(err);
    });
  }

}
